export const FJCloudTranscodingConfig = {
    cloudTranscodingInputKey: 'transcode/input/',
    cloudTranscodingExportKey: 'transcode/export/',
};
